module.exports = __webpack_public_path__ + "6417bf9de270237bed77a00e01a1f624.pdf";